<template>
    <div class="has-text-centered">
        <div class="app-block  p-md">
            <div>
                <p><strong>Vous souhaitez payer par prélèvement bancaire</strong></p>
                <p>Veuillez remplir l'ordre de prélévement ci-joint et le renvoyer à l'adresse indiquée ci-dessous ou par mail à <a href="mailto:sni@diderot-education.com">sni@diderot-education.com</a></p>

                <div class="columns p-lg">
                    <div class="column is-offset-1 is-two-fifths">
                        <a href="/docs/Direct debit mandate" target="_blank">
                            <i class="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>
                            <br><span class="has-text-black is-italic">Mandat de prélèvement</span>
                        </a>

                    </div>
                    <div class="column is-two-fifths">
                        <a href="/docs/EN_SEPA Direct Debit Mandate_0.pdf" target="_blank">
                            <i class="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>
                            <br><span class="has-text-black is-italic">Direct debit mandate</span>
                        </a>

                    </div>
                </div>


                <div class="admission-address has-background-white-ter">
                    <strong>Service National des Inscriptions - Diderot Education</strong>
                  <br>8 rue Hautefeuille
                  <br>75006 Paris
                    <br>France
                </div>
            </div>


            <hr>

            <div class="has-text-centered">
                <transition name="slide-fade">
                    <div class="has-text-danger">{{ errorMsg }}</div>
                </transition>
                <button :class="'button button-save ' + isLoading" @click="send">Je règle par prélèvement bancaire</button>
            </div>


        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        data () {
            return {
                isLoading: '',
                errorMsg: ''
            }
        },
        props: {
            school: { type: Object },
            totalCheckout: { type: Number },
            candidate: { type: Object },
            guarantor: { type: Number },
            credit: { type: Number },
            discount: { type: Array },
        },
        computed: {
            ...mapGetters({
                status: 'orders/status'
            }),
            ...mapGetters(
                'orders', [
                    'orderRef',
                    'cartChoices',
                    'selectedOrder'
                ]
            ),
            application () {
                return this.candidate.applications
            },
        },
        methods: {
            ...mapActions(
                'orders', [
                    'orderCheckout'
                ]
            ),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            send: function () {
                this.toggleLoading()
                const order = {}
                order.id = this.selectedOrder ? this.selectedOrder.id:this.orderRef
                order.cart = this.cartChoices
                order.guarantor = this.guarantor
                order.order_date = new Date()
                order.payment_mode = 'BANK-DEBIT'
                order.payment_total = this.totalCheckout
                order.credit = this.credit
                order.discount = this.discount
                order.payment_currency = this.school.fees_currency
                order.payment_number = 1
                order.school = this.$route.params.school
                order.payments = [ {
                    'date': new Date(),
                    'amount': this.totalCheckout,
                    'number': 1
                } ]
                this.orderCheckout(order).then((result) => {
                    if (this.status === 200) {
                        this.toggleLoading()
                        this.$emit('send')
                    } else if (this.status === 403) {
                        this.toggleLoading()
                        this.$emit('notAuthenticated')
                    } else {
                        this.toggleLoading()
                        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                    }
                }).catch(() => {
                    this.toggleLoading()
                    this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                })
            }
        }
    }
</script>
